'use client';

import NumberFlow from '@number-flow/react';
import { useEffect, useRef } from 'react';
import { Numeric } from '@/lib/types/common';
import { formatMoney, isBelowMoneyThreshold } from '@/lib/utils/formatAmount';

interface AnimatedUSDTextProps {
  value: Numeric;
  alwaysShowDecimals?: boolean;
  className?: string;
}

export function AnimatedUSDText({
  value,
  alwaysShowDecimals = false,
  className,
}: AnimatedUSDTextProps) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const numeric = Number(value);
  // Below the threshold there is no number to animate — show "> $0.001".
  if (isBelowMoneyThreshold(numeric)) {
    return <span className={className}>{formatMoney(numeric, { prefix: '$' })}</span>;
  }

  return (
    <NumberFlow
      value={numeric}
      prefix="$"
      format={{
        minimumFractionDigits: alwaysShowDecimals ? 3 : 0,
        maximumFractionDigits: 3,
        trailingZeroDisplay: alwaysShowDecimals ? 'auto' : 'stripIfInteger',
      }}
      locales="en-US"
      animated={!isFirstRender.current}
      className={className}
      willChange
    />
  );
}
